import React, { ReactElement } from 'react';
import { useFormikContext } from 'formik';

import { displayCategoriaColore, flattenKeys, formNameToNice } from '../utils';
import { useCategoria } from '../reducers';


interface ownProps {
  name: string,
  displayName?: string,
  help_text?: string | ReactElement,
}


const CategoriaSelector = (props: ownProps) => {
  let categorie = useCategoria(props);

  const { values, setFieldValue } = useFormikContext();

  const nice_name = props.displayName ? props.displayName : formNameToNice(props.name);

  let help_text;
  if (props.help_text) {
    if (typeof props.help_text == "string") {
      help_text = <p className="form-text text-muted">{props.help_text}</p>;
    } else {
      help_text = props.help_text
    }
  }

  const flattenedValues = flattenKeys(values);

  const setValue = (event: any) => {
    const category_id = Number(event.currentTarget.value);

    const selected = Object.keys(flattenedValues).includes(props.name) ? flattenedValues[props.name] as number[] : [] as number[];

    if (!!category_id) {
      const index = selected.indexOf(category_id)
      let new_value;
      if (index > -1) {
        new_value = selected.filter((_, indexItem) => indexItem != index)
      } else {
        new_value = selected.concat([category_id])
      }
      setFieldValue(props.name, new_value)
    }
  }

  return (
    <div className="form-group row">
      <label className="col-sm-2 col-form-label" htmlFor={props.name}>
        {nice_name}
      </label>
      <div className="col-sm">
        <div className="input-group">
          {categorie &&
            categorie.map(item => {
              const isSelected = Object.keys(flattenedValues).includes(props.name) && flattenedValues[props.name].includes(item.id);
              let badge = "badge-" + displayCategoriaColore(item.id).toString();
              if (!isSelected) {
                badge = "badge-clouds"
              }
              return (
                <label key={`categoria-${item.id}`}>
                  <span className={`badge py-1 px-1 mx-1 ${badge}`}>{item.nome}</span>

                  <input
                    name={props.name}
                    type="checkbox"
                    onChange={setValue}
                    value={item.id}
                    style={{ display: "none" }}
                  />
                </label>
              )
            })
          }
        </div>
        {help_text}
      </div>
    </div>
  );
}


export default CategoriaSelector;
